// extracted by mini-css-extract-plugin
export default {"bgColor":"#474747"};